import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import * as moment from 'moment';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { DetalleCargaLiquid } from 'src/app/Models/detcargaliq/detalle-carga-liquid';
import { DetalleFactura } from 'src/app/Models/factura/detallefactura/detalle-factura';
import { Filtro } from 'src/app/Models/filtro/filtro';
import { Gastos } from 'src/app/Models/gastos/gastos';
import { Ingreso } from 'src/app/Models/ingreso/ingreso';
import { Liquidacion } from 'src/app/Models/liquidacion/liquidacion';
import { Personal } from 'src/app/Models/personal/personal';
import { PrintDetail } from 'src/app/Models/print/print-detail';
import { PrintHeader } from 'src/app/Models/print/print-header';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { NotifyService } from 'src/app/Service/notify.service';

@Component({
  selector: 'app-printliquidacion',
  templateUrl: './printliquidacion.component.html',
  styleUrls: ['./printliquidacion.component.css'],
  providers: [DatePipe],
})
export class PrintliquidacionComponent implements OnInit {
  public cabecera: PrintHeader = new PrintHeader();
  public detalle: PrintDetail[] = [];
  public detfactus: DetalleFactura[] = [];
  public sumacantidad: number = 0;
  public sumapreuni: number = 0;
  public sumatotal: number = 0;
  public pagventas: any = 0;
  public rangofechas: RangoFechas = new RangoFechas();
  public today = new Date();
  public usuario: Usuario = new Usuario();
  public funcion: Function;
  public isShow: boolean = false;
  public alertType: AlertType = new AlertType();
  public fechaHoraActual: Date;
  public liquidacion = new Liquidacion()
  public detcargas: DetalleCargaLiquid[] = []
  public gastos: Gastos[] = []
  public ingresos: Ingreso[] = []
  public ventasliquidacion: any[] = []
  public totalProductos: number
  public listapersonal: Personal[] = [];
  public filtro: Filtro = new Filtro()
  public otrasventas: any;
  public isedit: boolean = false;
  public personal: Personal = new Personal();
  liquidacionID: string = '0';

  @ViewChild('pagina', null) public pagina: ElementRef;
  constructor(private title: Title, private data: DataService, private notify: NotifyService, private datePipe: DatePipe, private auth: AuthService, private route: ActivatedRoute, private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    //this.liquidacionID = this.route.snapshot.paramMap.get('liquidacionId');
    //this.filtro.fecha = moment(new Date()).format('YYYY-MM-DD')
    //this.getLiquidacion()
  }


  public isbutton: Boolean = true;
  click: boolean = false;
  async print() {
    const doc = new jsPDF({ orientation: 'p', unit: 'px', format: [820, this.pagina.nativeElement.offsetHeight + 80] });
    doc.setDisplayMode('');
    let html = this.pagina.nativeElement;
    await doc.html(this.pagina.nativeElement, { margin: 0, x: 0, y: 0 });
    var blobPDF = new Blob([], { type: 'application/pdf' });
    var blobUrl = URL.createObjectURL(blobPDF);  //<--- THE ERROR APPEARS HERE
    console.log(blobUrl);
    window.open(blobUrl);  // will open a new tab
    doc.autoPrint({ variant: 'non-conform' });
    doc.save("informe_liquidacion.pdf");
  }
  mouseenter() {
    if (!this.click) {
      this.isbutton = true;
    } else {
      this.isbutton = false;
    }
  }

  back() {
    this.router.navigateByUrl("/liquidacion");
  }


  getLiquidacion() {
    this.data.GetFromValue('bol_liquid', this.liquidacionID).subscribe(r => {

      console.log("Respuesta completa:", r);
      console.log("Tipo de liquidacion en respuesta:", typeof r.liquidacion);
      console.log("Valor billeteraelec:", r.liquidacion.billeteraelec);
      console.log("Tipo billeteraelec:", typeof r.liquidacion.billeteraelec);

      // En lugar de asignar directamente, crea una nueva instancia
      this.liquidacion = Object.assign(new Liquidacion(), r.liquidacion);

      console.log("post asignacion", this.liquidacion);
      console.log("billeteraelec después:", this.liquidacion.billeteraelec);

      this.getOtrasVentas()
      this.getpersonal()
      this.getVentasLiquidacion()
      this.getDetCargas()
      this.getGastos()
      this.getIngresos()
    })
  }

  getpersonal() {
    this.data.GetFromValue(this.data.api.personal, 'idpersonal', this.liquidacion.idpersonal).subscribe(r => {
      this.personal = r[0]
      console.log('obtenida', this.personal);
    })
  }

  // getGastos() {
  //   this.data.GetFromId('getgastosfliq', this.liquidacion.idliquida).subscribe(r => {
  //     this.gastos = r;
  //     console.log('Gastos', r);
  //   })
  // }

  // getIngresos() {
  //   this.data.GetFromId('getingresosfliq', this.liquidacion.idliquida).subscribe(r => {
  //     this.ingresos = r;
  //   })
  // }

  // getDetCargas() {
  //   this.data.GetFromValue(this.data.api.detallecarga, 'idliquida', this.liquidacion.idliquida).subscribe(r => { this.detcargas = r; console.log('Mostrando detcargas', this.detcargas); })
  // }

  // getVentasLiquidacion() {
  //   this.filtro.fecha = this.liquidacion.fecha
  //   this.filtro.idvende = this.liquidacion.idpersonal
  //   this.data.Post('getventasliq', this.filtro).subscribe(r => {
  //     this.ventasliquidacion = r.productos;
  //     this.totalProductos = r.totalProductos;
  //   })
  // }

  getVentasLiquidacion() {
    if (!this.liquidacion.fecha || !this.liquidacion.idpersonal) {
      this.ventasliquidacion = [];
      this.totalProductos = 0;
      return;
    }

    this.filtro.fecha = this.liquidacion.fecha;
    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    this.data.Post('getventasliq', this.filtro).subscribe(
      r => {
        this.ventasliquidacion = r.productos || [];
        this.totalProductos = r.totalProductos || 0;

        // ✅ Calcular total de ventas
        if (this.ventasliquidacion.length > 0) {
          this.liquidacion.tot_venta = this.ventasliquidacion.reduce(
            (total, detalle) => total + parseFloat(detalle.Total.toString()),
            0
          );
        } else {
          this.liquidacion.tot_venta = 0;
        }

        // ✅ Calcular neto después de obtener las ventas
        this.SumaNeto();

        console.log('Ventas obtenidas:', this.ventasliquidacion);
        console.log('Total ventas:', this.liquidacion.tot_venta);

      },
      error => {
        console.error('Error al obtener ventas:', error);
        this.ventasliquidacion = [];
        this.totalProductos = 0;
        this.liquidacion.tot_venta = 0;
        this.SumaNeto();
      }
    );
  }

  getDetCargas() {
    this.data.GetFromValue(this.data.api.detallecarga, 'idliquida', this.liquidacion.idliquida).subscribe(
      r => {
        this.detcargas = r || [];
        console.log('Mostrando detcargas', this.detcargas);
      },
      error => {
        console.error('Error al obtener detalle de carga:', error);
        this.detcargas = [];
      }
    );
  }

  getGastos() {
    if (!this.liquidacion.idliquida) {
      this.gastos = [];
      return;
    }

    this.data.GetFromId('getgastosfliq', this.liquidacion.idliquida).subscribe(
      r => {
        this.gastos = r || [];

        // ✅ Calcular total de gastos
        if (this.gastos.length > 0) {
          this.liquidacion.gasto = this.gastos.reduce(
            (total, detalle) => total + parseFloat(detalle.total.toString()),
            0
          );
        } else {
          this.liquidacion.gasto = 0;
        }

        // ✅ Recalcular neto
        this.SumaNeto();

        console.log('Gastos:', this.gastos);
        console.log('Total gastos:', this.liquidacion.gasto);

      },
      error => {
        console.error('Error al obtener gastos:', error);
        this.gastos = [];
        this.liquidacion.gasto = 0;
        this.SumaNeto();
      }
    );
  }

  getIngresos() {
    if (!this.liquidacion.idliquida) {
      this.ingresos = [];
      return;
    }

    this.data.GetFromId('getingresosfliq', this.liquidacion.idliquida).subscribe(
      r => {
        this.ingresos = r || [];

        // ✅ Calcular total de ingresos
        if (this.ingresos.length > 0) {
          this.liquidacion.cobro_credito = this.ingresos.reduce(
            (total, detalle) => total + parseFloat(detalle.total.toString()),
            0
          );
        } else {
          this.liquidacion.cobro_credito = 0;
        }

        // ✅ Recalcular neto
        this.SumaNeto();

        console.log("Ingresos:", this.ingresos);
        console.log("Total cobro crédito:", this.liquidacion.cobro_credito);

      },
      error => {
        console.error('Error al obtener ingresos:', error);
        this.ingresos = [];
        this.liquidacion.cobro_credito = 0;
        this.SumaNeto();
      }
    );
  }

  getOtrasVentas1() {
    console.log(this.liquidacion.fecha);

    this.filtro.fecha = this.liquidacion.fecha

    //this.filtro.idvende = this.liquidacion.idpersonal
    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;


    this.data.Post('getotrasventas', this.filtro).subscribe(r => {
      console.log(r);

      if (r.length > 0) {
        this.liquidacion.tarjeta = 0
        this.liquidacion.otorga_credito = 0
        //this.liquidacion.billeteraelec = 0
        r.forEach(elem => {
          switch (elem.tarjeta) {
            case "01":
              this.liquidacion.tarjeta = parseFloat(this.liquidacion.tarjeta.toString()) + parseFloat(elem.sum_tarjetachq)
              break;
            case "13":
              this.liquidacion.otorga_credito = parseFloat(this.liquidacion.otorga_credito.toString()) + parseFloat(elem.sum_tarjetachq)
              break;
            case "15":
              this.liquidacion.billeteraelec = parseFloat(this.liquidacion.billeteraelec.toString()) + parseFloat(elem.sum_tarjetachq)
              break;
            default:
              this.liquidacion.tarjeta = this.liquidacion.tarjeta + 0
              this.liquidacion.otorga_credito = this.liquidacion.otorga_credito + 0
              console.log("Billetera", this.liquidacion.billeteraelec)
              this.liquidacion.billeteraelec = this.liquidacion.billeteraelec + 0
              break;
          }
        });

      };
    })
  }

  getOtrasVentas() {
    console.log(this.liquidacion.fecha);

    this.filtro.fecha = this.liquidacion.fecha;

    this.filtro.idvende = typeof this.liquidacion.idpersonal === 'object'
      ? this.liquidacion.idpersonal.idpersonal
      : this.liquidacion.idpersonal;

    this.data.Post('getotrasventas', this.filtro).subscribe(r => {
      console.log("Otras ventas recibidas:", r);

      // ✅ Resetear TODOS los valores (incluyendo billeteraelec y fise)
      this.liquidacion.tarjeta = 0;
      this.liquidacion.otorga_credito = 0;
      this.liquidacion.billeteraelec = 0;
      this.liquidacion.fise = 0;

      if (r && r.length > 0) {
        r.forEach(elem => {
          const importe = parseFloat(elem.sum_importe) || 0;

          // ✅ Usar elem.codigo en lugar de elem.tarjeta
          switch (elem.codigo) {
            case "01":
              this.liquidacion.tarjeta += importe;
              break;
            case "13":
              this.liquidacion.otorga_credito += importe;
              break;
            case "15":
              this.liquidacion.billeteraelec += importe;
              break;
            case "17":
              this.liquidacion.fise += importe;
              break;
            default:
              console.log(`Código de pago no reconocido: ${elem.codigo}`);
              break;
          }
        });

        // ✅ Redondear a 2 decimales
        this.liquidacion.tarjeta = parseFloat(this.liquidacion.tarjeta.toFixed(2));
        this.liquidacion.otorga_credito = parseFloat(this.liquidacion.otorga_credito.toFixed(2));
        this.liquidacion.billeteraelec = parseFloat(this.liquidacion.billeteraelec.toFixed(2));
        this.liquidacion.fise = parseFloat(this.liquidacion.fise.toFixed(2));
      }

      this.SumaNeto();

      console.log("Liquidacion actualizada:", {
        tarjeta: this.liquidacion.tarjeta,
        otorga_credito: this.liquidacion.otorga_credito,
        billeteraelec: this.liquidacion.billeteraelec,
        fise: this.liquidacion.fise
      });
    });
  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  printer() {
    const doc = new jsPDF('p', 'mm', 'a5');
    const titulo = { text: 'INFORME DE LIQUIDACION', x: 50, y: 15 };

    const addHeader = () => {
      doc.setFontSize(11);
      doc.text(titulo.text, titulo.x, titulo.y);
      doc.setLineWidth(0.5);
      doc.line(titulo.x, titulo.y + 1, titulo.x + doc.getTextWidth(titulo.text), titulo.y + 1);
      doc.setFontSize(8);
      doc.text(`Vendedor: ${this.personal.nombre}`, 10, 22);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 85, 22);
      doc.text(`Vehiculo: ${this.liquidacion.placa}`, 10, 27);
      doc.text(`Fecha y hora: ${this.liquidacion.fecha} - ${this.liquidacion.hora}`, 85, 27);
    };

    const renderTable = (title: string, columns: string[], rows: any[], startY: number, showTitle: boolean) => {
      if (rows.length > 0) {
        if (showTitle) {
          doc.text(title, 10, startY - 2);
        }
        (doc as any).autoTable({
          head: [columns],
          body: rows,
          startY: startY,
          margin: { horizontal: 10, vertical: 30 },
          theme: 'grid',
          styles: { fontSize: 7, cellPadding: 1 },
          columnStyles: { 1: { halign: 'right' }, 2: { halign: 'right' }, 3: { halign: 'right' } },
          didDrawPage: (data: any) => {
            addHeader();
            doc.text(`Página ${data.pageNumber}`, 125, 10);
          }
        });
        return (doc as any).autoTable.previous.finalY + 3; // Incrementar Y
      } else {
        doc.text(`No hay registros en ${title}`, 10, startY);
        return startY + 5; // Incrementar Y sin tabla
      }
    };

    addHeader();

    // Definir tablas y renderizarlas
    let currentY = 35;

    // Tabla Detalle de Carga
    const detCargaRows = this.getTableRows('#detcarga tbody tr');
    currentY = renderTable("Detalle de carga", ['PRODUCTO', 'VIAJE', 'SALIDA', 'ENTRADA', 'PRESTAMO/DEVOLUCION'], detCargaRows, currentY, true);

    // Tabla Ventas
    const ventasRows = this.getTableRows('#ventas tbody tr', '#ventas tfoot tr');
    currentY = renderTable("Ventas", ['PRECIO', 'VENTAS', 'CANTIDAD', 'TOTAL'], ventasRows, currentY, false);

    // Tabla Gastos
    const gastosRows = this.getTableRows('#gastos tbody tr', '#gastos tfoot tr');
    currentY = renderTable("Gastos", ['GASTOS - CONCEPTO', 'TOTAL'], gastosRows, currentY, false);

    // Tabla Ingresos
    const ingresosRows = this.getTableRows('#ingresos tbody tr', '#ingresos tfoot tr');
    currentY = renderTable("Ingresos", ['INGRESOS - CONCEPTO', 'TOTAL'], ingresosRows, currentY, false);

    // Tabla Otros Pagos
    const otrosPagosRows = this.getTableRows('#otrospagos tbody tr');
    currentY = renderTable("Otros", ['OTROS MEDIOS DE PAGO - DESCRIPCION', 'TOTAL'], otrosPagosRows, currentY, false);
    console.log(otrosPagosRows)
    // Tabla Total
    const totalNetoRow = this.getTableRows('#totalNeto thead tr');
    //currentY = renderTable("Total", ['', ''], totalRows, currentY);
    (doc as any).autoTable({
      body: totalNetoRow,  // Solo contiene las filas del total
      startY: (doc as any).autoTable.previous.finalY + 3,  // Comienza debajo de la tabla anterior
      margin: { horizontal: 10, bottom: 0 },
      theme: 'grid',  // Puedes cambiar a 'plain' si deseas un estilo más sencillo
      columnStyles: {
        1: { halign: 'right' }
      },
      styles: {
        fontSize: 7,  // Tamaño de fuente
        fontStyle: 'bold', // Tamaño de fuente
        cellPadding: 1,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        const pageNumber = data.pageNumber;
        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);
      },
    });

    const totalRows = this.getTableRows('#total thead tr');
    //currentY = renderTable("Total", ['', ''], totalRows, currentY);
    (doc as any).autoTable({
      body: totalRows,  // Solo contiene las filas del total
      startY: (doc as any).autoTable.previous.finalY + 3,  // Comienza debajo de la tabla anterior
      margin: { horizontal: 10, bottom: 0 },
      theme: 'grid',  // Puedes cambiar a 'plain' si deseas un estilo más sencillo
      columnStyles: {
        1: { halign: 'right' }
      },
      styles: {
        fontSize: 7,  // Tamaño de fuente
        fontStyle: 'bold', // Tamaño de fuente
        cellPadding: 1,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        const pageNumber = data.pageNumber;
        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);
      },
    });

    const diferencia = this.getTableRows('#diferencia thead tr');
    console.log("Diferkjasdfasd: ", diferencia);

    (doc as any).autoTable({
      body: diferencia,  // Solo contiene las filas del total
      startY: (doc as any).autoTable.previous.finalY + 3,  // Comienza debajo de la tabla anterior
      margin: { horizontal: 10, bottom: 0 },
      theme: 'grid',  // Puedes cambiar a 'plain' si deseas un estilo más sencillo
      columnStyles: {
        1: { halign: 'right' }
      },
      styles: {
        fontSize: 7,  // Tamaño de fuente
        fontStyle: 'bold', // Tamaño de fuente
        cellPadding: 1,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        const pageNumber = data.pageNumber;
        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);
      },
    });

    // Guardar o imprimir el archivo PDF
    doc.autoPrint({ variant: 'non-conform' });
    const blob = doc.output('blob');
    const url = URL.createObjectURL(blob);
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = url;
    document.body.appendChild(iframe);
    iframe.onload = () => {
      if (iframe.contentWindow && typeof iframe.contentWindow.print === 'function') {
        iframe.contentWindow.print();
      }
    };
  }

  getTableRows(selector: string, footerSelector?: string) {
    const rows = document.querySelectorAll(selector);
    const dataRows: any[] = [];
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const rowData: any[] = [];
      cols.forEach(col => rowData.push(col.innerText));
      dataRows.push(rowData);
    });
    if (footerSelector) {
      const footer = document.querySelector(footerSelector);
      if (footer) {
        const cols = footer.querySelectorAll('th');
        const footerData: any[] = [];
        cols.forEach(col => footerData.push(col.innerText));
        dataRows.push(footerData);
      }
    }
    return dataRows;
  }


  // Agregar esta función en printliquidacion.component.ts
  SumaNeto() {
    const totVenta = this.toNumber(this.liquidacion.tot_venta);
    const cobro_credito = this.toNumber(this.liquidacion.cobro_credito);
    const gasto = this.toNumber(this.liquidacion.gasto);
    const billeteraelec = this.toNumber(this.liquidacion.billeteraelec);
    const fise = this.toNumber(this.liquidacion.fise);
    const otorga_credito = this.toNumber(this.liquidacion.otorga_credito);
    const tarjeta = this.toNumber(this.liquidacion.tarjeta);

    // Leer efectivo y deposito, convertir seguro
    const efectivo = this.toNumber(this.liquidacion.efectivo);
    const deposito = this.toNumber(this.liquidacion.deposito);

    // Asignar entrega = suma de los 2 (redondeo a 2 decimales)
    const entrega = Math.round((efectivo + deposito) * 100) / 100;
    this.liquidacion.entrega = entrega;

    // Calcular neto y diferencia (también redondeados)
    const neto = totVenta + cobro_credito - gasto - billeteraelec - fise - otorga_credito - tarjeta;
    this.liquidacion.neto = Math.round(neto * 100) / 100;

    const diferencia = Math.round((this.liquidacion.neto - this.liquidacion.entrega) * 100) / 100;
    this.liquidacion.diferencia = diferencia;

    console.log("Cálculos realizados:", {
      neto: this.liquidacion.neto,
      entrega: this.liquidacion.entrega,
      diferencia: this.liquidacion.diferencia
    });
  }

  // Función auxiliar para convertir valores a número de forma segura
  toNumber(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const num = parseFloat(value.toString());
    return isNaN(num) ? 0 : num;
  }
}
